import { Routes } from '@angular/router';
import { EmailComponent } from './components/email/email.component';
import { NameComponent } from './components/name/name.component';
import { PaymentResultComponent } from './components/payment-result/payment-result.component';
import { PaywallComponent } from './components/paywall/paywall.component';
import { PreparationComponent } from './components/preparation/preparation.component';
import { QuizStepComponent } from './components/quiz-step/quiz-step.component';
import { SignInWithEmailComponent } from './components/sign-in-with-email/sign-in-with-email.component';
import { StartComponent } from './components/start/start.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
      {
        path: '',
        redirectTo: 'start',
        pathMatch: 'full',
      },
      {
        path: 'quiz',
        redirectTo: 'quiz/0',
        pathMatch: 'full',
      },
      {
        path: 'quiz/:index',
        component: QuizStepComponent,
      },
      {
        path: 'start',
        component: StartComponent,
      },
      {
        path: 'checkout',
        canActivate: [authGuard],
        component: PaywallComponent,
      },
      {
        path: 'login',
        component: EmailComponent, // Use EmailComponent instead of LoginComponent
      },
      {
        path: 'ready',
        component: PreparationComponent,
      },
      {
        path: 'email-sign-in',
        component: SignInWithEmailComponent,
      },
      {
        path: 'name',
        component: NameComponent,
      },
      {
        path: 'result',
        component: PaymentResultComponent,
      },
        // Wildcard route for redirecting unmatched paths
  {
    path: '**',
    redirectTo: 'start',
  },
];